/**
 * Pre-compiled fr-FR messages for DraggableList
 * Generated by @internationalized/string-compiler
 * DO NOT EDIT MANUALLY
 */

export default {
  emptyMessage: `Déposer les articles ici`,
  removeButtonLabel: `Supprimer l'article`,
};
